import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { PlansComponent } from './plans-student/plans.component';
import { ZipCoverageComponent } from './zip-coverage/zip-coverage.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { DefaultPageComponent } from './default-page/default-page.component';
import { FacultyPlansComponent } from './plans-faculty/faculty-plans.component';
import { AlumniPlansComponent } from './plans-fan/alumni-plans.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';

import { Routes } from '@angular/router';
import { SearchComponent } from './search/search.component';
import { WhyComponent } from './why/why.component';
import { GiveAwayPage2Component } from './give-away-page2/give-away-page2.component';
import { GiveawayPage1Component } from './giveaway-page1/giveaway-page1.component';
import { GiveawayComponent } from './shared/giveaway/giveaway.component';
import { NewsroomComponent } from './newsroom/newsroom.component';
import { GiveawaysComponent } from './giveaways/giveaways.component';
import { GiveawayClosedComponent } from './giveaway-closed/giveaway-closed.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot([
		{ path: '', redirectTo: ':collegemobile', pathMatch: 'full' },
		{ path: 'default', component: DefaultPageComponent },

		{ path: 'search', component: SearchComponent },
		{ path: ':collegemobile', component: LandingPageComponent },
		{ path: ':collegemobile/landingpage', component: LandingPageComponent },

		{ path: ':collegemobile/student', component: PlansComponent },
		{ path: ':collegemobile/shop-faculty-plans', component: FacultyPlansComponent },
		{ path: ':collegemobile/fan', component: AlumniPlansComponent },
		{ path: ':collegemobile/why', component: WhyComponent},
		{ path: ':collegemobile/coveragemap', component: ZipCoverageComponent },
		{ path: ':collegemobile/giveawayentry/:guid', component: GiveawayPage1Component },
		{ path: ':collegemobile/giveawayconfirmation', component: GiveAwayPage2Component },
		{ path: ':collegemobile/giveaway-closed', component: GiveawayClosedComponent },
		{ path: ':collegemobile/newsroom', component: NewsroomComponent },
		{ path: 'shop-faculty-plans2', component: WhyComponent }, // this URL is used for testing purpose : to be removed later

		{ path: '**', redirectTo: 'default' },
      
    ],{ scrollPositionRestoration: 'top', anchorScrolling: "enabled" }),
    
  ],
  declarations: [
    AppComponent,
    PlansComponent,
    ZipCoverageComponent,
    LandingPageComponent,
    DefaultPageComponent,
    FacultyPlansComponent,
    AlumniPlansComponent,
    HeaderComponent,
    FooterComponent,
    SearchComponent,
    WhyComponent,
    GiveawayPage1Component,
    GiveAwayPage2Component,
    GiveawayComponent,
    NewsroomComponent,
    GiveawaysComponent,
    GiveawayClosedComponent,


  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}
